import classNames from 'classnames'
import { type MouseEventHandler } from 'react'
import { Typography } from 'shared/ui/Typography'
import { IconButton } from 'shared/ui/IconButton'
import { Icon, type IIconsVector } from 'shared/ui/Icon'
import type { IDropdownItem } from 'shared/ui/Dropdown'
import styles from './styles.module.scss'

const DEFAULT_ICON_COLOR = 'var(--content-primary-tertiary)'

export interface IChipIconProps {
  icon: IIconsVector
  iconColor?: string
  iconSize?: number
}

export interface IChipProps {
  label: string
  item?: IDropdownItem
  clickable?: boolean
  iconType?: 'button' | 'div'
  onDelete?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>
  variant?: 'primary' | 'secondary'
  iconL?: IChipIconProps
}

export const Chip = ({
  label,
  clickable = false,
  iconType = 'button',
  onDelete,
  item,
  variant = 'primary',
  iconL,
}: IChipProps) => {
  return (
    <div
      className={classNames(
        styles.wrap,
        styles[variant],
        { [styles.clickable]: clickable, [styles.withoutDelete]: !onDelete },
        item?.className
      )}
    >
      {iconL && (
        <Icon
          icon={iconL.icon}
          fontSize={iconL.iconSize ?? 16}
          color={iconL.iconColor ?? DEFAULT_ICON_COLOR}
        />
      )}
      <Typography
        ariaLabel='ChipLabel'
        variant='body-md-regular'
        color='var(--content-primary-primary)'
        ellipsis
      >
        {label}
      </Typography>
      {onDelete && (
        <IconButton
          color='transparent'
          size='mini'
          tag={iconType}
          icon='close'
          variant='icon'
          fontSize={16}
          onClick={onDelete}
          ariaLabel='ChipClose'
          className={styles.icon}
        />
      )}
    </div>
  )
}
